   <template>

    <div class="" >

      <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-large
        rounded="sm"
        style="height:100vh"
        variant="dark"
        id="loader"
      >


      <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF"><HeaderConsumer/></b-col>
            <b-col cols="12 headerM"><HeaderConsumerMobile/></b-col>
          </b-row>

           <br>
           <b-row>
             <b-col cols="12">
               Consumer No: <select class="customSelect" id="consList" @change="switchConsumer()">
               </select>
             </b-col>
           </b-row>
          <b-row>
            <b-col cols="12">
              <div>
                <b-tabs content-class="mt-3" justified active id="allTabs">
                  <b-tab title="Update Profile" @click ="showConsDetails('click')">
                    <b-card
                     title="Update Profile"
                     style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                     class="mb-2"
                     >

                     <hr/>
                              <b-row>
                                <b-col col cols="6" sm="6" md="6" lg="2">
                                    <span class="label">Consumer Number : </span>
                                </b-col>
                                <b-col col cols="6" sm="6" md="6" lg="3">
                                  <span id="consumerNumber" > </span>
                                </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="2" class="marginTop20px">
                                  <span class="label">Consumer Name : </span>
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                                <span id="consumerName"></span>
                              </b-col>
                            </b-row>

                          </br>
                            <b-row>
                              <b-col col cols="6" sm="6" md="6" lg="2" class="label" >
                                  Mobile No <span class="text-danger">*</span> :
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3">
                                  <b-form-input type="text" id="mobile" maxlength="10" autocomplete="off"  placeholder="Enter Mobile No" value="" trim >
                                  </b-form-input>
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="2" class="label marginTop20px">
                                  Email ID:
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                                 <b-form-input type="email" id="email" autocomplete="off"  placeholder="Enter Email ID " value="" trim >
                                  </b-form-input>
                              </b-col>
                            </b-row>
                            <br>
                            <b-row>
                              <b-col col cols="6" sm="6" md="6" lg="2" class="label ">
                                  Voter ID(EPIC) </span> :
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3">
                                <b-form-input type="text" maxlength="10" id="voterId"  placeholder="Enter Voter ID" trim  >
                                 </b-form-input>
                              </b-col>
                              <!-- <b-col col cols="6" sm="6" md="6" lg="2" class="label marginTop20px">
                                 Aadhaar No </span> :
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                                <b-form-input type="text" maxlength="12" id="aadhaar"  placeholder="Enter Aadhar No" trim  >
                                 </b-form-input>
                              </b-col>

                            </b-row>
                            <br>
                            <br>
                            <b-row> -->
                              <b-col col cols="6" sm="6" md="6" lg="2" class="label ">
                                  Occupation <span class="text-danger">*</span> :
                              </b-col>
                              <b-col col cols="6" sm="6" md="6" lg="3">
                                <b-form-select id="occupation" class="mb-3" v-model="selected">
                                   <b-form-select-option value="null" >Please select an option</b-form-select-option>
                                   <b-form-select-option value="Govt">Govt Employee</b-form-select-option>
                                   <b-form-select-option value="SemiGovt">Semi Govt Employee</b-form-select-option>
                                   <b-form-select-option value="PSU">PSU Employee</b-form-select-option>
                                   <b-form-select-option value="Others">Others</b-form-select-option>
                                 </b-form-select>
                              </b-col>
                            </b-row>
                            <br>
                            <br>
                            <b-row>
                            <b-col col cols="6" sm="3" md="3" lg="3" offset="3" offset-sm="4" offset-md="4" offset-lg="4">
                                <!-- <b-button id="updateButton" @click="sendOtp()" block squared variant="primary">
                                  UPDATE</b-button> -->
                                  <b-button id="updateButton" @click="updateConsumer()" block squared variant="primary">
                                    UPDATE</b-button>
                                 <br>
                            </b-col>
                          </b-row>
                        </b-card>
                  </b-tab>

                  <b-tab title="New Recharge" @click="newRecharge()">
                    <b-card class="mb-2 "   style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;">
                     <div>
                      <input id="sdCode" hidden />
                        <div class="">
                          <b-overlay
                            :show="show"
                            spinner-variant="primary"
                            spinner-large
                            rounded="sm"
                            style="height:100vh"
                            variant="dark"
                            id="loader"
                          >

                            <b-container fluid style="padding-top: 0px;text-align:left;display:block" id="consBillDiv" >

                              <div class="paddingLeft30px">
                                <!-- <br>
                                <p style="color:red">We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.</p> -->

                              <div id="BillDetails" class="billDetails">
                                <b-row>
                                  <b-col cols=12>
                                      <span class="heading">Consumer Details</span>
                                  </b-col>
                                </b-row>
                                <hr/>

                                <b-row class="paddingRow">
                                <b-col cols="12" sm="2" md="2" lg="2">
                                  <span class="label">Consumer Name : </span>
                                </b-col>
                                <b-col cols="12" sm="2" md="2" lg="2">
                                  <span class="" id="consNamePrepaid"></span>
                                </b-col>
                                <b-col cols="12" sm="2" md="2" lg="2">
                                  <span class="label">Location : </span>
                                </b-col>
                                <b-col cols="12" sm="3" md="4" lg="4">
                                  <span class="" id="subDiv"></span>
                                </b-col>
                              </b-row>
                              <b-row class="paddingRow">
                                <b-col cols="12" sm="2" md="2" lg="2">
                                  <span class="label">Meter No : </span>
                                </b-col>
                                <b-col cols="12" sm="2" md="2" lg="2">
                                  <span class="" id="meterNo"></span>
                                </b-col>
                                <!-- <b-col cols="12" sm="2" md="2" lg="2">
                                  <span class="label">Category : </span>
                                </b-col>
                                <b-col cols="12" sm="2" md="2" lg="2">
                                  <span class="" id="category"></span>
                                </b-col> -->
                              </b-row>
                              <b-row class="paddingRow">
                                <b-col cols="12" sm="2" md="2" lg="2">
                                  <span class="label">Amount <span class="text-danger">*</span> :    </span>
                                </b-col>
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <b-form-input type="number" id="amount" placeholder="Recharge  Amount" trim ></b-form-input>
                                  </b-col>
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <span class="label">Confirm Amount <span class="text-danger">*</span> :    </span>
                                  </b-col>
                                    <b-col cols="12" sm="2" md="3" lg="3">
                                      <b-form-input type="number" id="confirmAmount" placeholder="Confirm Recharge  Amount" trim ></b-form-input>
                                    </b-col>
                              </b-row>
                              <b-row class="paddingRow">
                                <b-col cols="12" sm="2" md="2" lg="2">
                                  <span class="label">Mobile No <span class="text-danger">*</span> :</span>
                                </b-col>
                                <b-col cols="12" sm="2" md="2" lg="2">
                                  <b-form-input type="number" id="mobileNo" placeholder="Enter Mobile No" trim />
                                </b-col>
                                <b-col cols="12" sm="2" md="2" lg="2">
                                  <span class="label">Email ID :</span>
                                </b-col>
                                <b-col cols="12" sm="2" md="3" lg="3">
                                  <b-form-input type="email" id="emailId" placeholder="Enter Email ID" trim />
                                </b-col>
                              </b-row>
                            <br>
                              <b-row>
                                    <b-col cols="12"sm="3" md="3" lg="3" offset-sm="4" offfset-md="4" offset-lg="4">

                                        <b-button block squared variant="primary" @click="payNow()">
                                         <b-icon icon="credit-card" animation=""  >  </b-icon> PAY NOW
                                       </b-button>

                                    </b-col>
                                  </b-row>
                                </div>
                            </div>

                        </b-container>
                        <b-container fluid style="padding-top: 100px;text-align:left;display:none" id="billdeskRequestDiv">

                          <br><br>
                        <b-row id="spinner" style="display:block">
                          <b-col cols=12 align="center">
                            <h3 class="">Processing Payment Request...</h3>
                            <br><br>
                              <b-spinner style="width: 10rem; height: 10rem;" variant="primary" label="Spinning"></b-spinner>
                            <br><br><br>
                             <h5 style="color:red">Please do not press back or refresh button</h5>
                          </b-col>
                        </b-row>
                        <b-row id="errorDiv" style="display:none">
                          <b-col cols=12 align="center">
                            <h2 style="color:red" id="errorMsg"></h2>
                            <br><br>
                            <b-button onclick="window.location.reload();">Go Back</b-button>
                          </b-col>
                        </b-row>
                      </b-container>
                      <br><br>
                      </b-overlay>
                    </div>
                      </div>

                   </b-card>
                 </b-tab>



                 <b-tab title="Recharge History" @click="getRechargeHistory('click')">
                   <b-card
                    title="Consumer Recharge Details"
                    style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                    class="mb-2"
                    >

                    <b-row>
                      <b-col col cols='12' sm="12" md="12" lg="12">
                        <b-table  responsive striped  :items="voucherList" :fields="voucherListFields">
                          <template   v-slot:cell(link)="data">
                            <span  v-html="data.value"></span>
                         </template>
                        </b-table>
                        </b-col>

                    </b-row>

                  </b-card>
                </b-tab>


                <b-tab title="TDS Adjustment Statement" @click="showTdsAdjustment('click')" >
                  <b-card
                   title="TDS(194Q) Adjustment Statement"
                   style="   box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                   class="mb-2"
                   >
                  <span id="tdsSpan" style="color:red;font-weight:500;font-size:1.2rem;"></span>

                    <b-table id="tdsTable" responsive :items="tdsAdjustment" :fields="tdsAdjustmentFields" style="font-size:0.8rem;display:none">
                      <template v-slot:cell(challan_link)="data">
                        <span  v-html="data.value"></span>
                     </template>
                    </b-table>
                  </b-card>
                </b-tab>

                
                </b-tabs>

                
              </div>
            </b-col>
          </b-row>
  </b-container>

  </b-overlay>
    <br>



    <b-button id="success-btn" @click="$bvModal.show('successModal')" hidden></b-button>
    <b-button id="failure-btn" @click="$bvModal.show('failureModal')" hidden></b-button>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg" style="color:red"></span>
      <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="profilesuccessModal" centered  scrollable title="Profile Update" hide-footer>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
        </svg>
        <p class="success">Profile Successfully Updated !<br><br>
        <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage()" >OK</b-button>
      </p>
    </b-modal>

    <b-modal id="profilefailureModal" centered  scrollable title="Profile Update" hide-footer>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
      </svg>
      <p class="error">Profile Update Failed ! </p>
    </b-modal>

    
    
    
    <b-modal id="redirectModal" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="redirectModalMsg" style="color:red">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-info" @click="redirect()">OK</b-button>
    </b-modal>
    </div>

  </template>


  <script>
  import Chart from 'chart.js';
  import HeaderConsumer from '@/components/HeaderConsumer.vue'
  import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
  import Vue from 'vue'
  import Vuex from 'vuex'
  import axios from 'axios'
  var CryptoJS = require("crypto-js");
  var checked = 0;
  var thColor = '#0288d1';
  var oldMob="";
  var click = [];
  var sdCode = "";
  var consNo = "";
  var mobile="";
  var accessToken="";
  var consList;
  var consName="";
  var vendor="";
  var isSmart = "";
  
  Vue.use(Vuex);
  import * as pdfMake from 'pdfmake/build/pdfmake';
  import * as pdfFonts from 'pdfmake/build/vfs_fonts';
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  

  export default {
    name: 'ConsumerDashboard',
    components: {

      'HeaderConsumer' : HeaderConsumer,
      'HeaderConsumerMobile' : HeaderConsumerMobile
      //MarqueeText

    },
    data() {
        return {
          
            undertakingAccepted: false,//checkbox in undertaking
            
            inputValue: "",
            show: false,
            show1: false,
            messageToSend:"",
            reqUrl:"",
            consType:"",
            selected: null,
            
            voucherList : [],
            voucherListFields: [
              { key: 'txnId', label: 'Transaction Id',thStyle: {width: '15vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
              { key: 'voucherAmt', label: 'Voucher Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
              { key: 'PaymentDate', label: 'Payment Date',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
              { key: 'link', label: 'Download Voucher',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
            ],
            tdsAdjustmentFields: [
            { key: 'sl_no', label: 'SL No',thStyle: {width: '3vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'cons_no', label: 'Consumer No',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'tan_no', label: 'TAN No',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'bill_no', label: 'Bill No',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'tds_amt', label: 'TDS Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'challan_no', label: 'Challan No',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'challan_date', label: 'Challan Date',thStyle: {width: '7vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'challan_amt', label: 'Challan Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'upload_date', label: 'Upload Date',thStyle: {width: '7vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'processed_flag', label: 'Processed',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'processed_date', label: 'Processed Date',thStyle: {width: '7vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'challan_link', label: 'Challan Link',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }

          ],
            tdsAdjustment:[],
          consList:[],
          consDetails:[],

            tdsAdjustment:[],

          message : [
            "",
            "No Consumer Found for this Consumer Number",
            "No Outstanding Bill Found for this Consumer Number",
            "This Consumer Number is Blocked",
            "No Bill Found for Payment",
            "",
            "Server Busy! Kindly Try Again After Sometime.",
            "Transaction Already in Progress",
            "Error in Initiating Payment Request with Billdesk"
          ]
        }
    },

    methods:
    {
      preventNumbers(event) {
      if (event.key >= '0' && event.key <= '9') {
        event.preventDefault(); // Block numbers
      }
    },
    formatCapacity() {
  const inputcapacity = document.getElementById('NetCapacity');

  if (inputcapacity) 
  {

    let formattedValue = inputcapacity.value;
    formattedValue = formattedValue.replace(/[^0-9.]/g, '');

    
    let decimalCount = (formattedValue.match(/\./g) || []).length;
    if (decimalCount > 1) {
      
      formattedValue = formattedValue.substring(0, formattedValue.lastIndexOf('.'));
    }

    
    if (formattedValue.includes('.')) {
      let parts = formattedValue.split('.');
      parts[1] = parts[1].substring(0, 2); // Limit to 2 decimal places
      formattedValue = parts.join('.');
    } else {
      
      formattedValue = formattedValue + '.00';
    }

    
    
    inputcapacity.value = formattedValue;

    
    //('Formatted NetCapacity', formattedValue);

    return formattedValue;
  }


  return '';
},




  
      closeModal(){
        this.$bvModal.hide('model')
      },
      reloadPage()
      {
        window.location.reload();
      },
      redirect(){
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("consList");
      sessionStorage.removeItem("selectedCons");
      window.location.href = "/website/";
      return false;
      },
      switchConsumer()
    {
     this.show=true;
     var consNo = document.getElementById("consList").value;
     
     var consType;
     
     var parent= this;
     let data = JSON.stringify({
        "consNo": consNo,
        "mobileNo":mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon+'/api/web/auth/getConsDetails',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
        data : data
      };
      var parent=this;
      axios.request(config)
      .then((response) => {
        parent.show=false;
        //console.log(response.data);
        if(response.data.message=="00")
          {
          sessionStorage.setItem("selectedCons", consNo);
          consType = response.data.connType;
          if(consType == "POSTPAID")
              {
                window.location.href = "/website/ConsumerDashboardPostpaid";
                return false;
              }
          else  if(consType == "SMART POSTPAID")
              {
                window.location.href = "/website/ConsumerDashboardSmartPostpaid";
                return false;
              }
          else  if(consType == "PREPAID")
              {
                window.location.href = "/website/ConsumerDashboardPrepaid";
                return false;
              }
          else  if(consType == "SMART PREPAID")
              {
                window.location.href="/website/ConsumerDashboardSmartPrepaid";
                return false;
              }
          }
        else{
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Consumer Not Found";
        }
      })
      .catch((e) => {
        parent.show=false;
        console.log("Caught :::::::::::::::", e.message);
         if(e.response.data.error=="Forbidden")
        {
          parent.$bvModal.show('redirectModal');
          document.getElementById("redirectModalMsg").innerHTML="Session Expired, Please log in again";
        }
      });

   },
      getRechargeHistory(action)
      {
        console.log("this.voucherList.length::::"+this.voucherList.length)

        if((action=="change")||(action=="click" && this.voucherList.length==0))
         {
           var consNo = document.getElementById("consList").value;
      
           
          let data = JSON.stringify({
                "consNo": consNo,
                "mobileNo":mobile
              });

              let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: this.$urlCommon+'/api/web/auth/voucherReprint',
                headers: { 
                  'Authorization': accessToken, 
                  'Content-Type': 'application/json'
                },
                data : data
              };
              
              this.show=true;
              var parent = this;
              axios.request(config)
              .then((response) => {
                
            console.log(response.data);

             parent.show= false;
            
             var temp = [];
               response.data.forEach(element => {
                     var res1= element.paymentDt.split("-");
                     var paymentDt = res1[2]+"/"+res1[1]+"/"+res1[0];
                     var obj = {
                     "txnId":element.transactionId,
                     "voucherAmt":element.voucherAmount,
                     "PaymentDate":element.paymentDt,
                     "link": "<a style='padding-left:40%' target='_blank' href='"+element.downloadLink+"'><img src='https://www.apdcl.org/website/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
                 }
                 temp.push(obj)

             })
             //console.log(temp)
             this.voucherList = temp
           })
           .catch((e) => {
             parent.show= false;
             parent.$bvModal.show('model');
             document.getElementById("modalMsg").innerHTML=e.response.data.message;
             console.log("Caught :::::::::::::::", e.message);

         })
       }
    },

showConsDetails(action)
{
  

if((action=="change")||( action=="click" && this.consDetails.length==0))
{
var consNo = document.getElementById('consList').value;
this.show= true;

var parent= this;
     let data = JSON.stringify({
        "consNo": consNo,
        "mobileNo":mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon+'/api/web/auth/getConsDetails',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
        data : data
      };
      var parent=this;
      axios.request(config)
      .then((response) => {
        parent.show=false;
        console.log(response.data);
        if(response.data.message=="00")
          {
            var data=response.data;
            oldMob = data.mobile_no;
            document.getElementById("consumerNumber").innerHTML = data.cons_no;
            consumerNumberGlobal = data.cons_no;
            document.getElementById("consumerName").innerHTML = data.cons_name;
            document.getElementById("mobile").value = data.mobile_no;
            consumermobileGlobal = data.mobile_no;
            consumerNameGlobal = data.cons_name;
            consumerAddressGlobal= data.cons_ADD1;
            document.getElementById("email").value = data.email;
            
            parent.selected = data.occupation;
            if (data.voter_ID== null || data.voter_ID=="")
               document.getElementById("voterId").placeholder = "Enter Voter No";
            else
               document.getElementById("voterId").placeholder = data.voter_ID;
            parent.consDetails.push(data.cons_no);
          }
          else{
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Consumer Not Found";
        }

})
.catch((e) => {
  parent.show= false;
    console.log("Caught", e);
 
     if(e.response.data.error=="Forbidden")
        {
          parent.$bvModal.show('redirectModal');
          document.getElementById("redirectModalMsg").innerHTML="Session Expired, Please log in again";
        }

})
}
},

showTdsAdjustment(action)
{
  if((action=="change")||( action=="click" && this.tdsAdjustment.length==0))
  {
  var consNo = document.getElementById("consList").value;
  var parent = this;
  this.show=true;

  let data = JSON.stringify({
        "consNo": consNo,
        "mobileNo":mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon+'/api/web/auth/tdsStatement',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
        data : data
      };
      
      this.show=true;
      var parent = this;
      axios.request(config)
      .then((response) => {
        
    console.log(response.data);
    parent.show=false;
  var status= response.data.status;
  var data= response.data.tdsStatement;
  var temp = [];
  var i =1;
  if(status==="Success")
  {
    document.getElementById("tdsTable").style.display="block";
    document.getElementById("tdsSpan").style.display="none";
    data.forEach(element => {
          // var res1= element.payment_DATE.split("-");
          // var paymentDateFormatted = res1[2]+"/"+res1[1]+"/"+res1[0];
          var processedDate = "---"
          if(element.processed_DATE!=null)
            processedDate=element.processed_DATE.split("T")[0];
          var uploadDate = "---"
            if(element.upload_DATE!=null)
              uploadDate=element.upload_DATE.split("T")[0];
          var obj = {
          "sl_no": i++,
          "cons_no":element.cons_NO,
          "tan_no":element.tan_NO,
          "bill_no":element.bill_NO,
          "tds_amt":element.tds_AMT_DEDUCTED,
          "challan_no":element.challan_NO,
          "challan_date":element.challan_DATE,
          "challan_amt":element.challan_AMT,
          "upload_date":uploadDate,
          "processed_flag":element.processed_FLAG,
          "processed_date":processedDate,
          "challan_link": "<a style='padding-left:40%' target='_blank' href='"+element.challan_LINK+"'><img src='"+parent.$urlCommon+"/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
      }
      temp.push(obj);
  })

  parent.tdsAdjustment = temp;

  }
  else {
    document.getElementById("tdsTable").style.display="none";
    document.getElementById("tdsSpan").style.display="block";
    document.getElementById("tdsSpan").innerHTML=response.data.message;

  }


})
.catch((e) => {
  parent.show= false;
  parent.$bvModal.show('model');
  document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
  console.log("Caught :::::::::::::::", e.message);

})
}
},

updateConsumer(){

  console.log("inside update consumer");
  var consNo = document.getElementById("consList").value;
  var mobNo = document.getElementById("mobile").value;
  var email = document.getElementById("email").value;
  var occupation = document.getElementById("occupation").value;
  var voterId = document.getElementById("voterId").value;

  var mobregx = /^[5-9]\d{9}$/
  if(!mobregx.test(mobNo))
    {
      // document.getElementById('failure-btn-mob').click();
      this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
        title: `Alert`,
        variant: 'danger',
        solid: true
      })
    return
    }

    var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if(!emailRegex.test(email) && email!="")
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter Valid Email !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("email").focus();
      return
      }

      
          var voterIdRegex = /^([a-zA-Z]){3}([0-9]){7}?$/g;
          if(!voterIdRegex.test(voterId) && voterId != "" )
              {
                // document.getElementById('failure-btn-mob').click();
                this.$bvToast.toast('Enter Valid Voter ID !', {
                  title: `Alert`,
                  variant: 'danger',
                  solid: true
                })
                document.getElementById("voterId").focus();
              return
              }



      let data = JSON.stringify({
        "consNo": consNo,
        "email" : email,
        "mobNo" : mobNo,
        "voterId" : voterId,
        "occupation" : occupation,
        "mobileNo":mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon+'/api/web/auth/updateConsumerDetails',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
        data : data
      };
      
      this.show=true;
      var parent = this;
      axios.request(config)
      .then((response) => {
        parent.show= false;
        var msg1=response.data.status;
                  if(msg1=="success")
                  {
                    
                    parent.$bvModal.show('profilesuccessModal');
                  }
                  else {
                    
                    parent.$bvModal.show('model');
                    document.getElementById("modalMsg").innerHTML=response.data.message;
                  }
      })
      .catch((e) => {
         parent.show= false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML="Profile Update Failed";
            console.log("Caught :::::::::::::::", e.message);
          })
        
},

newRecharge() {

      consNo = document.getElementById("consList").value;
      var parent =this;

      if (consNo.toString().length!=12)
        {
          this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return;
        }
        
     let data = JSON.stringify({
        "consNo": consNo,
        "mobileNo":mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon+'/api/web/auth/prepaidRecharge',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
        data : data
      };
      var parent=this;
      this.show= true;
      axios.request(config)
      .then((response) => {
        parent.show=false;
        var data=response.data.prepaidConsDetails;
            var msg=response.data.message;

            if(msg=="Valid") {
              
              sdCode = data.sdCode;
              consName = data.consumerName;
              vendor = data.vendorName;
              isSmart = data.isSmart;
              document.getElementById("consNamePrepaid").innerHTML=data.consumerName;
              document.getElementById("subDiv").innerHTML=data.address;
              document.getElementById("meterNo").innerHTML=data.meterNo;
              // document.getElementById("category").innerHTML=data.categoryName;
              parent.show= false;
              document.getElementById("BillDetails").classList.add("showBillDetails");
            }
            else
            {
              console.log("inside Error")
              parent.show= false;
              document.getElementById("BillDetails").style.display="none";
              parent.$bvModal.show("model");
              if (data.errorcode == "No connection to secure service." || data.errorcode == "Could not connect Genus services")
                document.getElementById("modalMsg").innerHTML="Error Connecting to Prepaid Meter Server";
              else
                document.getElementById("modalMsg").innerHTML=msg;

            }
      })
      .catch((e) => {
        parent.show= false;
        parent.$bvModal.show('model');
        document.getElementById("modalMsg").innerHTML="Sorry, Please Try Again Later";
        console.log("Caught :::::::::::::::", e.message);

      })
 
  
},

payNow()
    {
      var mobileNo = document.getElementById("mobileNo").value;
      var emailId = document.getElementById("emailId").value;
      var amountPaid = document.getElementById("amount").value;
      var confirmAmount = document.getElementById("confirmAmount").value;
      if (emailId=="")
      {
        emailId="NA";
      }
    var dataToSend = {
      "consNo": consNo,
      "amountPaid": amountPaid,
      "mobileNo":mobileNo,
      "email":emailId,
      "consName":consName,
      "vendor":vendor
    }
    console.log(dataToSend);
    if (amountPaid != confirmAmount)
          {
            this.$bvToast.toast('Enter same amount  !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("confirmAmount").focus();
            return;
          }

      if ( (amountPaid<100 || amountPaid>5000) && isSmart!="Y" )
          {
            this.$bvToast.toast('Enter Amount between Rs. 100.00 - Rs. 5000.00 !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("amount").focus();
            return;
          }
          if ((parseInt(amountPaid)%100)!= 0 )
              {
                this.$bvToast.toast('Enter Amount Multiple of 100 !', {
                  title: `Alert`,
                  variant: 'danger',
                  solid: true
                })
                document.getElementById("amount").focus();
                return;
              }
      if (mobileNo.length!=10)
          {
            this.$bvToast.toast('Enter 10 Digit Mobile Number !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("mobileNo").focus();
            return;
          }


   
    document.getElementById("consBillDiv").style.display="none";
    document.getElementById("billdeskRequestDiv").style.display="block";
    var parent=this;

    //axios.post( this.$urlCommon+'/api/onlineprepaid/pgrequest?consNo='+consNo+'&subDiv='+sdCode+"&amountPaid="+amountPaid+"&mobileNo="+mobileNo+"&email="+emailId)
    axios.post( this.$urlCommon+'/api/v2/onlineprepaid/pgrequest',dataToSend)
    .then((response) => {
      console.log(response.data);
      var data=response.data;
      var status=response.data.message;

      var reqUrl = "";
      var messageToSend = "";

      if(status=="00") {
        reqUrl = data.action;
        messageToSend= data.msg;
        const dataToNewPage = {reqUrl: reqUrl, messageToSend: messageToSend };
        const queryString = new URLSearchParams(dataToNewPage).toString();
        window.open(`/website/ConsumerDashboardBBPSpage?${queryString}`,'_blank');
        window.location.reload();
      }
      else
      {
        document.getElementById('spinner').style.display = 'none';
        document.getElementById('errorDiv').style.display = 'block';
        document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
        this.$bvModal.show("model");
        document.getElementById("msg").innerHTML=parent.message[parseInt(status)];
      }
    })
    .catch((e) => {
    console.log("Caught", e);
    this.show= false;
    this.$bvModal.show("model");
    document.getElementById("msg").innerHTML=e;
    document.getElementById("BillDetails").classList.remove("showBillDetails");
    })

    },
  closeModal(){
    this.$bvModal.hide('model')
  },
  closeModalH(){
    this.$bvModal.hide('holdingModal')
  }

},
    mounted()
    {
      if (sessionStorage.getItem("accessToken")) {
    // document.getElementById("consName").innerHTML=mobile;
    // document.getElementById("consNameMb").innerHTML=mobile;
    mobile = sessionStorage.getItem("mobile");
    accessToken = sessionStorage.getItem("accessToken");
    consList = JSON.parse(sessionStorage.getItem("consList"));
    console.log("consList Length::::"+consList.length)
    if(parseInt(consList.length)>0)
      {
        consList.forEach(element => {
        var option1 = document.createElement("option");
        option1.text = element;
        option1.value = element;
        var select1 = document.getElementById("consList");
        select1.appendChild(option1);
        })
    //parent.switchConsumer();
     document.getElementById("consList").value=sessionStorage.getItem("selectedCons");
     this.showConsDetails('change');

     }
    else {
      parent.$bvModal.show('model');
      document.getElementById("modalMsg").innerHTML="No Consumer Mapped to This Mobile number";
       
     }
    }
    else
     {
       this.$router.push({ path: '/' })
    
     }
    }

  }

  </script>


  <style scoped="true">
  .paddingRow{
    padding:0.7rem;
  }
  .label{
  font-weight:600;
  }
  .agreement{
  font-weight:600;
  color:#263238;
  
  }
  
.declaration
{
  color:#263238;
  font-weight:600;
  text-decoration: underline;
}
.decl {
  color:#263238;
  font-weight:200;
  font-size: 14px;
}
.agreement-container {
  width: 98%;
  max-width: 1000px;
  margin: 20px auto;
  padding: 30px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
}

.agreement-content {
  height: 400px; 
  overflow-y: auto;
  padding: 15px;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #f9f9f9;
}

.agreement-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

.center {
  text-align: center;
  font-weight: bold;
}

.agreement h6 {
  margin-top: 20px;
  font-weight: bold;
  color: #007bff;
}
  .customSelect
  {

  border: 1px solid #039be5 ;
  color: #0277bd    ;
  border-radius: 5px;
  height: 1.8rem;
  width: 10rem;
  font-weight: 600;

  }
  .customSelect:hover
  {
  cursor:pointer;
  border: 2px solid #039be5;
  color: #1565c0  ;
  border-radius: 5px;
  height: 1.8rem;
  width: 10rem;
  font-weight: 600;
  }
  

  .modalFont{
    width: 100px;
    display: block;
    margin: 40px auto 0;
  }

  .path {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
  }
  .path.circle {
    -webkit-animation: dash 0.9s ease-in-out;
    animation: dash 0.9s ease-in-out;
  }
  .path.line {
    stroke-dashoffset: 1000;
    -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
    animation: dash 0.9s 0.35s ease-in-out forwards;
  }
  .path.check {
    stroke-dashoffset: -100;
    -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
    animation: dash-check 0.9s 0.35s ease-in-out forwards;
  }

  p {
    text-align: center;
    margin: 20px 0 60px;
    font-size: 1.25em;
  }
  p.success {
    color: #73AF55;
  }
  p.error {
    color: #D06079;
  }
  @-webkit-keyframes dash {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes dash {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @-webkit-keyframes dash-check {
    0% {
      stroke-dashoffset: -100;
    }
    100% {
      stroke-dashoffset: 900;
    }
  }
  @keyframes dash-check {
    0% {
      stroke-dashoffset: -100;
    }
    100% {
      stroke-dashoffset: 900;
    }
  }
  .headerF{
    display: block;
  }
  .headerM{
    display: none;
  }
  .OnlinePaymentCardStyle{
    padding:0;
    box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;
    width:30%;
    margin-left:35%;
    text-align:center;
    min-height:50vh;
  }
  .marginTop{
    margin-top: -10px;
  }
  .marginTop20px{
    margin-top: none;
  }
  @media (max-width: 768px) {
      .headerF{
        display: none;
      }
      .headerM{
        display: block;
      }

      .marginTop{
        margin-top: 20px;
      }
      .marginTop20px{
        margin-top: 20px;
      }
    }
  @media (max-width: 576px) {

    .marginTop20px{
      margin-top: 20px;
    }
  }
  </style>
